export const B2C_FB_PIXEL_ID = process.env.NEXT_PUBLIC_B2C_FB_PIXEL_ID;

export const pageview = () => {
  if (
    typeof window !== 'undefined' &&
    window.fbq &&
    typeof window.fbq === 'function'
  ) {
    try {
      window.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Facebook Pixel PageView tracking failed:', error);
    }
  }
};

// https://developers.facebook.com/docs/facebook-pixel/advanced/
export const event = (name, options = {}) => {
  if (
    typeof window !== 'undefined' &&
    window.fbq &&
    typeof window.fbq === 'function'
  ) {
    try {
      window.fbq('track', name, options);
    } catch (error) {
      console.warn(`Facebook Pixel event tracking failed for ${name}:`, error);
    }
  }
};

export const customEvent = (name, options = {}) => {
  if (
    typeof window !== 'undefined' &&
    window.fbq &&
    typeof window.fbq === 'function'
  ) {
    try {
      window.fbq('trackCustom', name, options);
    } catch (error) {
      console.warn(
        `Facebook Pixel custom event tracking failed for ${name}:`,
        error
      );
    }
  }
};

export const trackEventToPixel = (pixelId, eventName, data = {}) => {
  if (
    typeof window !== 'undefined' &&
    window.fbq &&
    typeof window.fbq === 'function'
  ) {
    try {
      window.fbq('trackSingle', pixelId, eventName, data);
    } catch (error) {
      console.warn(
        `Facebook Pixel trackSingle failed for ${eventName}:`,
        error
      );
    }
  }
};

export const trackCustomToPixel = (pixelId, eventName, data = {}) => {
  if (
    typeof window !== 'undefined' &&
    window.fbq &&
    typeof window.fbq === 'function'
  ) {
    try {
      window.fbq('trackSingleCustom', pixelId, eventName, data);
    } catch (error) {
      console.warn(
        `Facebook Pixel trackSingleCustom failed for ${eventName}:`,
        error
      );
    }
  }
};
